import { createFileRoute } from "@tanstack/react-router";
import { StructuredSearchPage } from "./-components/structured-search.page";
import { structuredSearchRouteSearchParams } from "./-components/structured-search.url-state";

export const Route = createFileRoute("/_dashboard/$datasetSlug/search/$entityType")({
  validateSearch: structuredSearchRouteSearchParams,
  component: StructuredSearchPage,
});
